import { PaginatedQueryDTO } from 'infrastructure/dtos/pagination';
import { BaseApi } from '../base/BaseApi';
import { ICreativesApi } from './ICreativesApi';
import { CreativeResponseDTO } from 'infrastructure/dtos/creative';
import { ApiRoutes } from '../routes';
export class CreativesApi extends BaseApi implements ICreativesApi {
  public async getPaginatedCreativesWithPostRequest(queryDto: PaginatedQueryDTO): Promise<{
    data: CreativeResponseDTO[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  }> {
    return await this.callApi(ApiRoutes.Creatives.PaginatedCreativesWithPostRequest, queryDto);
  }
}
